<template>
  <div class="all">
    <div class="head">
      <div class="icon">
        <img v-lazy="require('@/assets/home/icon.png')" alt="" />
      </div>
      <h3>函驿通优势</h3>
    </div>
    <div class="foot">
      <div class="top">
        <div class="icon" @mouseover="changeInterval(index)" v-for="(item, index) in iconList" :key="index"
          :class="{ activ: isIndex == index }">
          <p :class="item.icon"></p>
          <p class="text" :class="{ tri: isIndex == index }">{{ item.name }}</p>
        </div>
      </div>
      <div class="bottom">
        <div class="optimal" v-for="(item, index) in list" :key="index">
          <p>{{ item.name }}</p>
          <div class="sp">{{ item.english }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iconList: [
        {
          icon: "iconfont icon-dianli",
          name: "一键注册快速出函",
        },
        {
          icon: "iconfont icon-zengjiaxianshiqi",
          name: "多类保函线上申请",
        },
        {
          icon: "iconfont icon-anquan1",
          name: "保函真伪在线查验",
        },
        {
          icon: "iconfont icon-a-saomachaxun_huaban1",
          name: "可视化进度查询",
        },
        {
          icon: "iconfont icon-qiandai_purse",
          name: "三级信息安全保护",
        },
        {
          icon: "iconfont icon-fuwuerji",
          name: "7*24小时在线客服",
        },
      ],
      isIndex: 0,
      listInfo: [
        {
          name: "一键手机注册登录",
          english: 'Bidding enterprises can register by one-click mobile phone'
        },
        {
          name: "内置项目信息一键申请",
          english: 'One-click application for built-in project information'
        },
        {
          name: "线上随时审核出函",
          english: 'Review and issue letters online at any time'
        },
      ],
      listInfo1: [
        {
          name: "一站式保函线上申请",
          english: 'One-stop guarantee online application',
        },
        {
          name: "自由选择保函类型",
          english: 'Freedom to choose the type of guarantee',
        },
        {
          name: "自主、自助两种模式随心可选",
          english: 'Independent and self-help modes are optional',
        },
      ],
      listInfo2: [
        {
          name: "银行直连在线出函",
          english: 'The bank directly connects the letter online',
        },
        {
          name: "国有融资担保公司",
          english: 'State-owned financing guarantee company',
        },
        {
          name: "一键查询保函真伪",
          english: 'One key to check the authenticity of the letter of guarantee',
        },
      ],
      listInfo3: [
        {
          name: "保函申请全流程电子化",
          english: 'The whole process of application for letter of guarantee is electronic',
        },
        {
          name: "微信全程订单跟踪",
          english: 'Wechat full order tracking',
        },
        {
          name: "申请进度尽在掌握",
          english: 'The application is on track',
        },
      ],
      listInfo4: [
        {
          name: "三级信息安全保护",
          english: 'Three-level information security protection',
        },
        {
          name: "区块链数据加密",
          english: 'Blockchain data encryption',
        },
        {
          name: "保护企业正常权益",
          english: 'Protect the normal rights and interests of enterprises',
        },
      ],
      listInfo5: [
        {
          name: "7*24在线保函申请",
          english: '7*24 Online Letter of Guarantee application',
        },
        {
          name: "一对一专属客服",
          english: 'One-to-one exclusive customer service',
        },
        {
          name: "全程跟踪答疑解惑",
          english: 'Follow up all questions and answers',
        },
      ],
      list: [
        {
          name: "一键手机注册登录",
          english: 'Bidding enterprises can register by one-click mobile phone',
        },
        {
          name: "内置项目信息一键申请",
          english: 'One-click application for built-in project information',
        },
        {
          name: "线上随时审核出函",
          english: 'Review and issue letters online at any time',
        },
      ],
    };
  },
  created() { },
  mounted() { },
  methods: {
    changeInterval(v) {
      this.isIndex = v;
      console.log(v, "111111");
      switch (this.isIndex) {
        case 0:
          this.list = this.listInfo;
          break;
        case 1:
          this.list = this.listInfo1;
          break;
        case 2:
          this.list = this.listInfo2;
          break;
        case 3:
          this.list = this.listInfo3;
          break;
        case 4:
          this.list = this.listInfo4;
          break;
        case 5:
          this.list = this.listInfo5;
          break;

        default:
          break;
      }
    },
    // change() {
    //   this.isIndex = 0;
    //   this.list = this.listInfo;
    // },
  },
};
</script>

<style lang='less' scoped>
.all {
  margin-top: 76px;

  .head {
    width: 100%;
    background-image: url("@/assets/home/youshi.png");
    background-repeat: no-repeat;
    background-size: cover;

    .icon {
      width: 114px;
      height: 74px;
      margin: 0 auto;

      img {
        width: 100%;
        height: 100%;
      }
    }

    h3 {
      text-align: center;
      margin-top: 15px;
      font-weight: bold;
      font-size: 24px;
    }
  }

  .foot {
    margin-top: 40px;

    .top {
      width: 1200px;
      display: flex;
      justify-content: space-between;
      margin: 20px auto 0px auto;

      .icon {
        text-align: center;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;

        .text {
          font-weight: bold;
          margin-top: 20px;
        }

        .tri {
          &::after {
            content: "";
            display: block;
            border-width: 15px;
            position: absolute;
            transform: translate(50px, -8px);
            border-style: solid dashed dashed solid;
            border-color: transparent transparent #f3f3f3 transparent;
            font-size: 0;
            line-height: 0;
          }
        }
      }

      .activ {
        color: #ffb520;
      }

    }

    .bottom {
      background-image: url("@/assets/home/advat1.png");
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      width: 100%;
      height: 248px;
      margin-top: 20px;
      align-items: center;
      justify-content: center;
      color: #353535;
      font-size: 17px;

      .optimal {
        position: relative;
        z-index: 999;
        margin-left: 80px;
        width: 20%;

        & ::after {
          content: "01";
          position: absolute;
          top: 0;
          left: 0;
          transform: translate(0, -50%);
          font-size: 88px;
          font-family: Baskerville Old Face;
          color: #353535;
          opacity: 0.11;
          font-weight: 400;
        }
      }

      p {
        font-weight: bold;
      }

      .sp {
        font-family: SourceHanSansCN;
        font-weight: 400;
        color: #353535;
        font-size: 9px;
        width: 55%;
        height: 20px;
      }

      .optimal:nth-child(2) ::after {
        content: "02";
      }

      .optimal:last-child ::after {
        content: "03";
      }
    }
  }

  .icon-fuwuerji,
  .icon-dianli,
  .icon-anquan1,
  .icon-a-saomachaxun_huaban1,
  .icon-qiandai_purse,
  .icon-zengjiaxianshiqi {
    font-size: 3em;
  }
}
</style>